import { defineStore } from 'pinia'
import { ref } from 'vue'
import { setLocale as setI18nLocale, setMessages } from '../i18n'
import http from '@/utils/http'

export const useAppStore = defineStore('app', () => {
  const isDark = ref(false)
  const currentLocale = ref('zh')
  const localesLoaded = ref(false)
  const currencySymbol = ref('¥') // Default to ¥, can be updated via system config
  const isDashboardFullscreen = ref(false)

  function toggleTheme() {
    isDark.value = !isDark.value
    if (isDark.value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    // Persist preference
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
  }

  function initTheme() {
    const saved = localStorage.getItem('theme')
    if (saved === 'dark') {
      isDark.value = true
      document.documentElement.classList.add('dark')
    }
  }

  async function loadLocales() {
    if (localesLoaded.value) return
    
    try {
      const additionalMessages = await http.get<Record<string, any>>('/api/v1/locales/additional')

      setMessages(additionalMessages as Record<string, any>)
      localesLoaded.value = true
      
      // Restore saved locale
      const savedLocale = localStorage.getItem('locale') || 'zh'
      setLocale(savedLocale)
    } catch (error) {
      console.error('Failed to load locales:', error)
      // Set default locale even if fetch fails
      const savedLocale = localStorage.getItem('locale') || 'zh'
      setLocale(savedLocale)
      localesLoaded.value = true
    }
  }

  function setLocale(lang: string) {
    currentLocale.value = lang
    setI18nLocale(lang)
    localStorage.setItem('locale', lang)
  }

  function setDashboardFullscreen(value: boolean) {
    isDashboardFullscreen.value = value
  }

  return {
    isDark,
    currentLocale,
    localesLoaded,
    currencySymbol,
    isDashboardFullscreen,
    toggleTheme,
    initTheme,
    loadLocales,
    setLocale,
    setDashboardFullscreen
  }
})
